'use client';

import { Suspense, lazy } from 'react';
import NewsCollectContentSkeleton from './NewsCollectContentSkeleton';

const NewsCollectContent = lazy(() => import('./index'));

type NewsCollectContentLazyProps = {
  children: React.ReactNode;
};

const NewsCollectContentLazy = ({ children }: NewsCollectContentLazyProps) => {
  return (
    <Suspense fallback={<NewsCollectContentSkeleton />}>
      <NewsCollectContent>{children}</NewsCollectContent>
    </Suspense>
  );
};

export default NewsCollectContentLazy;
